export function initSchemaFaqAccordion() {
    const faqItems = document.querySelectorAll(".schema-faq-section");

    if (!faqItems.length) return;

    faqItems.forEach((item) => {
        item.addEventListener("click", () => {
            const answer = item.querySelector(".schema-faq-answer");

            if (!answer || answer.classList.contains("sliding")) return;

            const isOpen = item.classList.contains("is-open");

            // Close all other FAQs
            faqItems.forEach((faq) => {
                if (faq === item) return;

                const otherAnswer = faq.querySelector(".schema-faq-answer");

                if (
                    !otherAnswer ||
                    !faq.classList.contains("is-open") ||
                    otherAnswer.classList.contains("sliding")
                ) {
                    return;
                }

                otherAnswer.classList.add("sliding");

                otherAnswer.style.height = `${otherAnswer.scrollHeight}px`;
                otherAnswer.style.overflow = "hidden";

                otherAnswer.offsetHeight;

                otherAnswer.style.transition = "height 300ms ease";
                otherAnswer.style.height = "0px";

                otherAnswer.addEventListener(
                    "transitionend",
                    () => {
                        faq.classList.remove("is-open");
                        otherAnswer.style.display = "none";
                        otherAnswer.style.removeProperty("height");
                        otherAnswer.style.removeProperty("overflow");
                        otherAnswer.style.removeProperty("transition");
                        otherAnswer.classList.remove("sliding");
                    },
                    { once: true }
                );
            });

            // If already open, close it
            if (isOpen) {
                answer.classList.add("sliding");

                answer.style.height = `${answer.scrollHeight}px`;
                answer.style.overflow = "hidden";

                answer.offsetHeight;

                answer.style.transition = "height 300ms ease";
                answer.style.height = "0px";

                answer.addEventListener(
                    "transitionend",
                    () => {
                        item.classList.remove("is-open");
                        answer.style.display = "none";
                        answer.style.removeProperty("height");
                        answer.style.removeProperty("overflow");
                        answer.style.removeProperty("transition");
                        answer.classList.remove("sliding");
                    },
                    { once: true }
                );

                return;
            }

            // Open current
            answer.classList.add("sliding");
            item.classList.add("is-open");

            answer.style.display = "block";
            answer.style.overflow = "hidden";
            answer.style.height = "0px";

            answer.offsetHeight;

            answer.style.transition = "height 300ms ease";
            answer.style.height = `${answer.scrollHeight}px`;

            answer.addEventListener(
                "transitionend",
                () => {
                    answer.style.removeProperty("height");
                    answer.style.removeProperty("overflow");
                    answer.style.removeProperty("transition");
                    answer.classList.remove("sliding");
                },
                { once: true }
            );
        });
    });
}